export let answer = [
    {
      questionId: 0,
      answerId: 1,
      answer: "",
      correct: false,
      ansOrder: 1,
    },
    {
      questionId: 0,
      answerId: 2,
      answer: "",
      correct: false,
      ansOrder: 2,
    },
    {
      questioId: 0,
      answerId: 3,
      answer: "",
      correct: false,
      ansOrder: 3,
    },
    {
      questionId: 0,
      answerId: 4,
      answer: "",
      correct: false,
      ansOrder: 4,
    },
  ];

  export const answerOptions = [
    { answerId: 1, label: "Option1", value: "Option1", id: 1 },
    { answerId: 2, label: "Option2", value: "Option2", id: 2 },
    { answerId: 3, label: "Option3", value: "Option3", id: 3 },
    { answerId: 4, label: "Option4", value: "Option4", id: 4 },
  ];

  export const config = {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
  };